import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { AutoIdProvider as SvgIdProvider } from '@techstyle/babel-plugin-inline-react-svg/auto-id';
import AppElement from './AppElement';
import AutoIdProvider from './AutoIdProvider';
import GlobalStyle from './GlobalStyle';
import ResponsiveViewport from './ResponsiveViewport';
import StickyProvider from './StickyProvider';
import defaultTheme from './styles/defaultTheme';

function createFontPreloadProps(font) {
  var preferredFormat = font.fileFormats ? font.fileFormats[0] : 'woff2';
  return {
    href: "".concat(font.fontFilePath, ".").concat(preferredFormat),
    type: "font/".concat(preferredFormat)
  };
}

function createFontPreloadLink(props) {
  return (
    /*#__PURE__*/
    // Not a component, just returns an element; pacify ESLint.
    // eslint-disable-next-line react/prop-types
    React.createElement("link", _extends({
      rel: "preload",
      as: "font",
      crossOrigin: "",
      key: props.href
    }, props))
  );
}

export default function styledComponentsExtension(theme) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$enableGlobal = options.enableGlobalFontFaces,
      enableGlobalFontFaces = _options$enableGlobal === void 0 ? true : _options$enableGlobal;
  theme = _objectSpread(_objectSpread(_objectSpread({}, defaultTheme), theme), {}, {
    breakpoints: _objectSpread(_objectSpread({}, defaultTheme.breakpoints), theme ? theme.breakpoints : null),
    colors: _objectSpread(_objectSpread({}, defaultTheme.colors), theme ? theme.colors : null)
  });
  return {
    id: 'styledComponents',
    server: process.browser ? undefined : {
      init() {
        require('./config');
      }

    },
    document: process.browser ? undefined : {
      getInitialProps: {
        enhance(getInitialProps) {
          var _require = require('styled-components'),
              ServerStyleSheet = _require.ServerStyleSheet;

          return /*#__PURE__*/function () {
            var _ref = _asyncToGenerator(function* (ctx) {
              var sheet = new ServerStyleSheet();
              var renderPage = ctx.renderPage;

              try {
                ctx.renderPage = () => renderPage({
                  enhanceApp: App => props => sheet.collectStyles( /*#__PURE__*/React.createElement(App, props))
                });

                var initialProps = yield getInitialProps(ctx);
                initialProps.styles = /*#__PURE__*/React.createElement(React.Fragment, null, initialProps.styles, sheet.getStyleElement());
                var fonts = theme.fonts || [];
                var preloadFonts = theme.preloadFonts || fonts.map(createFontPreloadProps);

                if (preloadFonts.length) {
                  initialProps.headTop = /*#__PURE__*/React.createElement(React.Fragment, null, preloadFonts.map(createFontPreloadLink), initialProps.headTop);
                }

                return initialProps;
              } finally {
                sheet.seal();
              }
            });

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }();
        }

      }
    },
    app: {
      render(props, children) {
        return /*#__PURE__*/React.createElement(ThemeProvider, {
          theme: theme
        }, /*#__PURE__*/React.createElement(AutoIdProvider, null, /*#__PURE__*/React.createElement(SvgIdProvider, null, /*#__PURE__*/React.createElement(StickyProvider, null, /*#__PURE__*/React.createElement(AppElement, null, /*#__PURE__*/React.createElement(ResponsiveViewport, null), /*#__PURE__*/React.createElement(GlobalStyle, {
          enableGlobalFontFaces: enableGlobalFontFaces
        }), children)))));
      }

    }
  };
}